<template>
    <div class="about">
        <Header :type="4"></Header>
        <div class="banner">
            <div class="banner_title">有车必用汽修宝，累计服务6000万用户</div>
            <div class="banner_desc">
                <div>
                    <div>
                        <span class="banner_desc_num">100</span>
                        <span class="banner_desc_unit">万+</span>
                    </div>
                    <div class="banner_desc_title">日查询量</div>
                </div>
                <div>
                    <div>
                        <span class="banner_desc_num">3500</span>
                        <span class="banner_desc_unit">万+</span>
                    </div>
                    <div class="banner_desc_title">注册用户</div>
                </div>
                <div>
                    <div>
                        <span class="banner_desc_num">1000</span>
                        <span class="banner_desc_unit">+</span>
                    </div>
                    <div class="banner_desc_title">合作厂商</div>
                </div>
                <div>
                    <div>
                        <span class="banner_desc_num">546</span>
                        <span class="banner_desc_unit">个</span>
                    </div>
                    <div class="banner_desc_title">合作品牌</div>
                </div>
            </div>
        </div>
        <div class="details main_width main_color m_0">
            <div class="details_info">
                <div class="details_info_title main_color">关于汽修宝</div>
                <p class="details_info_text">广州前实网络科技有限公司成立于2015年，汽修宝是国内首个以车架号(VIN）数据查询为核心，驱动配件交易的工具型平台。作为广州前实网络科技有限公司的旗舰产品，汽修宝通过人工智能与机器学习技术，构建了行业内领先的汽配底层数据体系，为汽车后市场提供高效、智能的解决方案。</p>
                <p class="details_info_text">汽修宝以数据为驱动，整合VIN码查询、EPC配件分解图、维修记录等多维度信息，打造了一个连接汽修厂与配件商的智能平台。通过Al技术，汽修宝不仅让配件查询更精准，还实现了智能交易与SaaS服务，推动行业从传统模式向数字化、智能化转型。</p>
            </div>
            <img src="/static/images2/about_details.webp" alt="">
        </div>
        <div class="about_development main_width main_color m_0">
            <div class="about_development_title">公司发展历程</div>
            <img src="/static/images2/about_development.webp" alt="">
            <div class="h5_about_development">
                <div class="h5_about_development_left">
                    <div class="h5_about_development_left_top">
                        <p class="h5_about_development_title">2016</p>
                        <p>用户量突破60万</p>
                        <p>完成种子轮融资</p>
                    </div>
                    <div class="h5_about_development_left_bottom">
                        <p class="h5_about_development_title">2021</p>
                        <p>投资成立源车件子公司</p>
                        <p>用户量达1000万</p>
                        <p>月活用户达120万</p>
                    </div>
                </div>
                <div class="h5_about_development_centen">
                    <div class="round"></div>
                    <div class="line"></div>
                    <div class="round"></div>
                    <div class="line"></div>
                    <div class="round"></div>
                    <div class="line"></div>
                    <div class="round"></div>
                    <div class="line"></div>
                    <div class="round"></div>
                    <div class="line short"></div>
                </div>
                <div class="h5_about_development_right">
                    <div>
                        <p class="h5_about_development_title">2015</p>
                        <p>公司正式成立</p>
                        <p>汽修宝App正式上线</p>
                    </div>
                    <div class="h5_about_development_right_conten">
                        <p class="h5_about_development_title">2017</p>
                        <p>用户量突破200万</p>
                        <p>完成天使轮融资</p>
                    </div>
                    <div class="h5_about_development_right_bottom">
                        <p class="h5_about_development_title">2024</p>
                        <p>集团营收达到6000万</p>
                        <p>累计行业注册用户3500万</p>
                        <p>日活25万</p>
                    </div>
                </div>
            </div>
        </div>
        <Team></Team>
        <div class="contact main_width m_0">
            <div class="contact_title main_color">联系我们</div>
            <div class="line"></div>
            <p>联系方式：020-36328593</p>
            <p>电子邮箱：qianshi@qxbapp.com</p>
            <p>公司地址：广东省广州市白云区云城西路888号白云绿地中心33楼</p>
            <img src="/static/images2/ditu.webp" alt="">
        </div>
    </div>
</template>
<script>
import Header from '../../components/header.vue'
import Team from './team.vue'
export default {
    name: "about",
    components: {
        Header,
        Team
    }
}
</script>
<style scoped lang="less">
@import "../../assets/style/utils.less";
div {
    box-sizing: border-box;
}
.banner {
    height: 20.833333333333336vw;
    // min-height: 330px;
    width: 100%;
    background-image: url('../../../static/images2/about_banner.webp');
    background-color: #ebf2fe;
    background-repeat: no-repeat;
    background-size: cover;
    color: #FFFFFF;
    text-align: center;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .banner_title {
        font-weight: 700;
        font-size: .px2vw(56)[@result];
        margin-bottom: .px2vw(47)[@result];
    }
    .banner_desc {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: .px2vw(20)[@result];
        & > div {
            margin: 0 .px2vw(63)[@result];
            .banner_desc_num {
                font-size: .px2vw(40)[@result];
            }
            .banner_desc_unit {
                font-size: .px2vw(26)[@result];
            }
            .banner_desc_title {
                margin-top: .px2vw(8)[@result];
                font-weight: 400;
            }
        }
    }
}
.details {
    width: .px2vw(1280)[@result];
    margin: .px2vw(64)[@result] auto 0;
    padding: .px2vw(93)[@result] .px2vw(24)[@result];
    display: flex;
    .details_info {
        flex: 1;
        margin-left: .px2vw(40)[@result];
        text-align: justify;
        font-weight: 400;
        font-size: .px2vw(14)[@result];
        color: #4E5969;
        margin-top: .px2vw(15)[@result];
        .details_info_title {
            font-weight: 700;
            font-size: .px2vw(32)[@result];
            margin-bottom: .px2vw(24)[@result];
            line-height: .px2vw(40)[@result];
        }
        .details_info_text {
            margin-bottom: .px2vw(16)[@result];
        }
    }
    img {
        width: .px2vw(648)[@result];
        height: .px2vw(364)[@result];
        margin-left: .px2vw(73)[@result];
    }
}
.about_development {
    font-weight: 700;
    font-size: .px2vw(32)[@result];
    text-align: center;
    margin-top: .px2vw(56)[@result];
    img {
        width: .px2vw(1323)[@result];
        height: .px2vw(449)[@result];
        margin-right: .px2vw(-43)[@result];
    }
    .h5_about_development {
        display: none;
    }
}
.contact {
    width: .px2vw(1280)[@result];
    padding: 0 .px2vw(64)[@result];
    font-weight: 400;
    font-size: .px2vw(16)[@result];
    color: #4E5969;
    line-height: .px2vw(24)[@result];
    margin-bottom: .px2vw(64)[@result];
    .contact_title {
        font-weight: 700;
        font-size: .px2vw(32)[@result];
        margin-bottom: .px2vw(12)[@result];
        line-height: .px2vw(40)[@result];
    }
    .line {
        width: .px2vw(480)[@result];
        height: 0px;
        border-bottom: 1px solid #D8D8D8;
        margin-bottom: .px2vw(16)[@result];
    }
    p {
        margin-bottom: .px2vw(16)[@result];
    }
    img {
        width: .px2vw(773)[@result];
        height: .px2vw(436)[@result];
    }
}

@media screen and (max-width: 900px) {
    .banner {
        height: .h5px2vw(332)[@result];
        background-image: url('../../../static/images2/h5/about_banner.webp');
        .banner_title {
            display: none;
        }
        .banner_desc {
            display: none;
        }
    }
    .details {
        width: 100%;
        max-width: 100%;
        margin: 0;
        padding: .h5px2vw(48)[@result] .h5px2vw(32)[@result] 0;
        flex-direction: column;
        .details_info {
            margin-left: 0;
            font-size: .h5px2vw(24)[@result];
            margin-top: 0;
            .details_info_title {
                font-size: .h5px2vw(32)[@result];
                margin-bottom: .h5px2vw(24)[@result];
                line-height: .h5px2vw(40)[@result];
                text-align: center;
            }
            .details_info_text {
                margin-bottom: .h5px2vw(24)[@result];
            }
        }
        img {
            width: 100%;
            height: .h5px2vw(385)[@result];
            margin-left: 0;
        }
    }
    .about_development {
        font-size: .h5px2vw(32)[@result];
        margin: .h5px2vw(48)[@result] 0 0;
        img {
            display: none;
        }
        .about_development_title {
            padding-bottom: .h5px2vw(80)[@result];
        }
        .h5_about_development {
            padding: 0 .h5px2vw(32)[@result];
            display: flex;
            // align-items: center;
            justify-content: center;
            & > div {
                font-weight: 400;
                font-size: .h5px2vw(24)[@result];
                line-height: .h5px2vw(32)[@result];
                p {
                    margin-bottom: .h5px2vw(8)[@result];
                }
            }
            .h5_about_development_title {
                font-weight: 700;
                font-size: .h5px2vw(32)[@result];
                color: #165DFF;
                line-height: .h5px2vw(40)[@result];
                margin-bottom: .h5px2vw(16)[@result];
            }
            .h5_about_development_left {
                text-align: right;
                .h5_about_development_left_top {
                    margin-top: .h5px2vw(186)[@result];
                }
                .h5_about_development_left_bottom {
                    margin-top: .h5px2vw(220)[@result];
                }
            }
            .h5_about_development_centen {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 0 .h5px2vw(32)[@result];
                .round {
                    width: .h5px2vw(24)[@result];
                    height: .h5px2vw(24)[@result];
                    border: .h5px2vw(2)[@result] solid #165DFF;
                    border-radius: 50%;
                }
                .line {
                    width: .h5px2vw(2)[@result];
                    height: .h5px2vw(150)[@result];
                    background: #165DFF;
                }
                .short {
                    height: .h5px2vw(130)[@result];
                }
            }
            .h5_about_development_right {
                text-align: left;
                .h5_about_development_right_conten {
                    margin-top: .h5px2vw(226)[@result];
                }
                .h5_about_development_right_bottom {
                    margin-top: .h5px2vw(220)[@result];
                }
            }
        }
    }
    .contact {
        width: auto;
        padding: 0 .h5px2vw(32)[@result];
        font-size: .h5px2vw(24)[@result];
        line-height: .h5px2vw(32)[@result];
        margin-bottom: .h5px2vw(80)[@result];
        .contact_title {
            font-size: .h5px2vw(32)[@result];
            margin-bottom: .h5px2vw(12)[@result];
            line-height: .h5px2vw(40)[@result];
        }
        .line {
            width: .h5px2vw(480)[@result];
            border-bottom: 1px solid #D8D8D8;
            margin-bottom: .h5px2vw(24)[@result];
        }
        p {
            margin-bottom: .h5px2vw(16)[@result];
        }
        img {
            width: .h5px2vw(588)[@result];
            height: .h5px2vw(332)[@result];
            margin-top: .h5px2vw(32)[@result];
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/about/index.vue